import dayjs from 'dayjs';
import Cookies from 'js-cookie';
import { TOKEN_SECRET } from '@mc/base';
import { aesEncode } from '@mc/encryption';

export const a8Integration = (a8: string) => {
  if (!a8) return;

  /** a8 账号id */
  const pid = 's00000024524001';
  const A8CookieName = `_a8_${pid}`;

  const a8Cookie = JSON.stringify({
    a8: a8,
    expireTime: dayjs().add(1, 'month').valueOf(),
  });

  Cookies.set(A8CookieName, aesEncode(a8Cookie, TOKEN_SECRET), { domain: '.notta.ai', expires: 30 });
};
